import React from "react";

import Preloader from "../components/preloader";
import Gotop from "../components/gotop";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tabs } from "react-tabs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dropdown from "react-dropdown";
import { useAsyncDebounce } from "react-table";
import { callApi } from "../constant/callApi";
import { RxCross1 } from "react-icons/rx";
import { FaBook } from "react-icons/fa";

import { useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Row,
  Form,
  InputGroup,
  Table,
  ButtonGroup,
} from "react-bootstrap";

import HamburgerMenu from "../assets/Mobile Menu/HamburgerMenu";

import Pagination from "../pages/paginationcomponent/pagination";
import PageSize from "../pages/paginationcomponent/pagesize";

function AllJobs() {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [advertisements, setAdvertisements] = useState([]);
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [isShowMobile, setShowMobile] = useState(false);
  const [value, setValue] = useState("");
  const [indexNo, setIndexNo] = useState(1);

  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedJob, setSelectedJobDetails] = useState({});
  const [viewApplicationPdf, setViewApplicationPdf] = useState(false);
  const [selectedPageSize, setSelectedPageSize] = useState(8);

  const navigate = useNavigate();
  
  // Temporary constant for Application Opening Time (2 PM)
  const APPLICATION_OPENING_TIME = "14:00"; // 2:00 PM in 24-hour format
  
  // SAS Token for blob storage access - loaded from environment variable with fallback
  const sasToken =
    process.env.REACT_APP_SAS_TOKEN ||
    "sp=racwd&st=2025-11-05T04:53:36Z&se=2027-01-01T13:08:36Z&spr=https&sv=2024-11-04&sr=c&sig=hQ%2BFCGxIoCVboFWlW7S%2Bp2BYyN2m%2FfAIYtu41mcHoPI%3D";

  // User Manual PDF URL with SAS token
  const userManualUrl = `https://odishminingblobsg.blob.core.windows.net/blobcontainer-sg/blobcontainer-sg/User%20Manual/User%20Manual%20ORMS-Candidate%20(V-final1).pdf?${sasToken}`;

  // Function to open user manual in new tab
  const openUserManual = () => {
    if (userManualUrl) {
      window.open(userManualUrl, "_blank", "noopener,noreferrer");
    } else {
      toast.warning("User manual not available.");
    }
  };

  const getAllAdvertisements = async () => {
    try {
      setLoading(true);
      const config = {
        method: "post",
        url: "Portal/all-jobs/getAllAdvertisement",
        data: {
          pageSize: selectedPageSize,
          currentPage: currentPage,
        },
      };
      const response = await callApi(config);
      if (response.data.code === 200) {
        console.log(response?.data?.data, "here");
        setAdvertisements(response?.data?.data);
        setTotalPage(Math.ceil(response.data.totalCount / selectedPageSize));
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getAppliedJobs = async () => {
    try {
      const config = {
        method: "post",
        url: "Portal/all-jobs/allJobAppliedByUser",
      };
      const response = await callApi(config);
      if (response.data.code === 200) {
        console.log("Applied Job", response?.data?.data);
        setAppliedJobs(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching applied jobs:", error);
    }
  };

  const handleRegisterFinal = async (item, post) => {
    console.log("item to AllJobs", item, post);
    const userId = sessionStorage.getItem("token");

    try {
      if (!userId) {
        navigate("/login");
      } else {
        navigate(
          `/apply-for-post?__application_id=${post?.jobApplicationForm}`,
          {
            state: { item, post },
          }
        );
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred. Please try again.");
    }
  };

  // Check if application opening time has passed
  const isOpeningTimePassed = (item) => {
    if (!item?.advertisementOpeningDate) {
      // If no opening date, assume it's open
      return true;
    }
    const openingDate = new Date(item.advertisementOpeningDate);
    const [hours, minutes] = APPLICATION_OPENING_TIME.split(":").map(Number);
    openingDate.setHours(hours, minutes, 0, 0);
    const now = new Date();
    return now >= openingDate;
  };

  const getTimeGap = (item) => {
    if (!item?.advertisementClosingDate || !item?.advertisementClosingTime) {
      return "Closing date or time is missing";
    }
    const closingDate = new Date(item.advertisementClosingDate);
    const [hours, minutes] = item.advertisementClosingTime
      .split(":")
      .map(Number);
    closingDate.setHours(hours, minutes, 0, 0);
    const now = new Date();
    const timeDifference = closingDate - now;
    if (timeDifference < 0) {
      return "The last date for applying to the vacancy is over.";
    }
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hoursLeft = Math.floor(
      (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutesLeft = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    );
    return `${days} days & ${hoursLeft} hr remaining.`;
  };

  const searchByPostName = async (query) => {
    try {
      const config = {
        method: "post",
        url: "Portal/all-jobs/searchByPostNameInAllJob",
        data: {
          query,
          pageSize: selectedPageSize,
          currentPage: currentPage,
        },
      };
      const response = await callApi(config);
      if (response.data.code === 200) {
        setAdvertisements(response?.data?.data);
        setTotalPage(Math.ceil(response.data.totalCount / selectedPageSize));
      }
    } catch (error) {
      console.error("Search Error:", error);
    }
  };

  const onPostNameSearch = useAsyncDebounce((item) => {
    if (item) {
      searchByPostName(item);
    }
  }, 500);

  useEffect(() => {
    getAppliedJobs(); // Fetch applied jobs when component loads
    if (value) {
      onPostNameSearch(value); // Pass value to the debounce function
    } else {
      getAllAdvertisements(); // Reset data if input is empty
    }
  }, [value, selectedPageSize, currentPage]);

  // Use a regex to match the search term in the content, case-insensitive

  return (
    <>
      <div className="allJobMain">
        <HamburgerMenu clname="alljob" />

        {loading ? (
          <Preloader />
        ) : (
          <>
            {" "}
            <Card className="registrationFont main-head-card px-5">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>All Jobs</span>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={openUserManual}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    backgroundColor: "#921d1e",
                    color: "#ffffff",
                    border: "none",
                    fontSize: "13px",
                    padding: "6px 12px",
                    borderRadius: "5px",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                >
                  <FaBook
                    style={{ fontSize: "14px", color: "#ffffff" }}
                  />
                  <span className="d-none d-md-inline">
                    User Manual
                  </span>
                </Button>
              </div>
            </Card>
            <section className="px-5 py-4 allJobContainer">
              <Card className="allJobCard">
                <div>
                  <div className="job-search-form job-search-form-responsive inner-form-map st1 pt-0 mt-0">
                    <Form id="top-form" className="pt-0 mt-0">
                      <Row className="align-items-center">
                        {/* Left Column */}
                        <Col md={4} className="d-flex align-items-center">
                          <div className="search-input-container allrole-search border-primary w-100 me-2 position-relative">
                            <input
                              style={{
                                paddingLeft: "35px",
                                paddingRight: "35px",
                              }}
                              value={value || ""}
                              onChange={(e) => setValue(e.target.value)}
                              placeholder="Post Name Search"
                              className="w-100"
                            />
                            <span
                              className="search-magnifier-icon-new pe-none position-absolute"
                              style={
                                {
                                  // left: "10px",
                                  // top: "50%",
                                  // transform: "translateY(-50%)",
                                }
                              }
                            >
                              <i className="bi bi-search search-icon-alljobs"></i>
                            </span>

                            {value && (
                              <span
                                className="clear-icon position-absolute"
                                style={{
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                }}
                                onClick={() => setValue("")}
                              >
                                <RxCross1 />
                              </span>
                            )}
                          </div>

                          <Button
                            variant=""
                            size="lg"
                            className="p-0 m-0"
                            onClick={() => {
                              getAllAdvertisements();
                            }}
                          >
                            <i className="bi bi-arrow-clockwise"></i>
                          </Button>
                        </Col>

                        {/* Right Column */}
                        <Col md={8} xs={12} className="text-end">
                          <div className="dropdown-container">
                            <PageSize
                              setCurrentPage={setCurrentPage}
                              pageSize={selectedPageSize}
                              setSelectedPageSize={setSelectedPageSize}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                  <div>
                    <div className="alljob-table-container">
                      <div className="row">
                        <Tabs className="col-12">
                          <div className="">
                            <Card className="mb-2 no-shadow d-none d-md-block job-card-header">
                              <Card.Body className="pt-0 pb-0 px-0 h-100">
                                <Row className=" g-0 h-100 align-content-center pt-1 tableHeadText">
                                  <Col
                                    xs="12"
                                    md="1"
                                    className="d-flex text-uppercase align-items-center justify-content-center tableHeadFont-allJobs"
                                  >
                                    SL NO.
                                  </Col>
                                  <Col
                                    xs="12"
                                    md="2"
                                    className="d-flex text-uppercase align-items-center justify-content-start tableHeadFont-allJobs"
                                  >
                                    ADVERTISEMENT NO
                                  </Col>
                                  <Col
                                    xs="12"
                                    md="2"
                                    className="d-flex text-uppercase  align-items-center justify-content-start tableHeadFont-allJobs"
                                  >
                                    POST NAME
                                  </Col>
                                  <Col
                                    xs="6"
                                    md="2"
                                    className="d-flex text-uppercase align-items-center justify-content-center tableHeadFont-allJobs"
                                  >
                                    STATUS
                                  </Col>
                                  <Col
                                    xs="6"
                                    md="3"
                                    className="d-flex text-uppercase align-items-center justify-content-start tableHeadFont-allJobs"
                                  >
                                    VACANCY
                                  </Col>
                                  <Col
                                    xs="6"
                                    md="2"
                                    className="d-flex text-uppercase align-items-center justify-content-center tableHeadFont-allJobs"
                                  >
                                    ACTION
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>

                            <div className="">
                              <>
                                {advertisements?.map((item, index) => {
                                  console.log(item?.advertisementHeading);
                                  const slNo =
                                    (currentPage - 1) * selectedPageSize +
                                    index +
                                    1;
                                  let daysLeft = getTimeGap(item);
                                  const isOpened = isOpeningTimePassed(item);
                                  const openingDate = item?.advertisementOpeningDate
                                    ? new Date(item.advertisementOpeningDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                      })
                                    : '';
                                  return (
                                    <>
                                      <Card
                                        key={item?._id}
                                        className="mb-2 shadow-sm"
                                        style={{
                                          borderRadius: "10px",
                                        }}
                                      >
                                        <Card.Body className="pt-0 pb-0 px-0 h-100">
                                          <Row className="g-0 h-100 align-content-center pt-2 pb-2">
                                            <Col
                                              xs="6"
                                              md="1"
                                              className="d-flex flex-column job-card-col align-items-start align-items-md-center justify-content-center mb-1 mb-md-0 text-start text-md-center ps-xs-3"
                                            >
                                              <div className="job-data-card d-md-none">
                                                Sl No.
                                              </div>
                                              <div className="d-flex align-items-center">
                                                <p className="mb-0">{slNo}</p>
                                              </div>
                                            </Col>

                                            <Col
                                              xs="6"
                                              md="2"
                                              className="d-flex flex-column job-card-col align-items-start justify-content-center mb-1 mb-md-0 text-start ps-xs-3"
                                            >
                                              <div className="job-data-card d-md-none">
                                                ADVERTISEMENT NO
                                              </div>
                                              <div
                                                className="tableBodyFont-top text-start text-md-start"
                                                style={{
                                                  wordBreak: "break-word",
                                                  overflowWrap: "break-word",
                                                  whiteSpace: "normal",
                                                }}
                                              >
                                                {item?.advertisementNumber}
                                                <a
                                                  href={
                                                    item?.advertisementDocument
                                                  }
                                                  target="__blank"
                                                  className="icon-download ms-2 mt-2"
                                                ></a>
                                              </div>
                                            </Col>
                                            <Col
                                              xs="8"
                                              md="2"
                                              className="d-flex flex-column job-card-col align-items-start justify-content-center mb-1 mb-md-0 text-start ps-xs-3"
                                            >
                                              <div className=" d-md-none job-data-card">
                                                POST NAME
                                              </div>
                                              <div
                                                to="#"
                                                className="tableBodyFont-top text-start text-md-start"
                                              >
                                                {`${item?.postDetails?.posting?.postName?.designationName}` ||
                                                  ""}
                                              </div>
                                            </Col>
                                            <Col
                                              xs="4"
                                              md="2"
                                              className="d-flex flex-column justify-content-center align-items-center text-center "
                                            >
                                              {daysLeft ===
                                              "The last date for applying to the vacancy is over." ? (
                                                <span
                                                  className="badge closedBadge pt-2 pb-2 ps-3 pe-3 tableBodyFont-top "
                                                  // style={{ width: "100px" }}
                                                >
                                                  Inactive
                                                </span>
                                              ) : (
                                                <span
                                                  className="badge activeBadge pt-2 pb-2 ps-3 pe-3 tableBodyFont-top "
                                                  // style={{ width: "100px" }}
                                                >
                                                  Active
                                                </span>
                                              )}
                                              {/* <div className=" text-small d-md-none job-data-card">STATUS</div> */}
                                            </Col>
                                            <Col
                                              xs="8"
                                              md="3"
                                              className=" job-card-col align-items-start text-start"
                                            >
                                              <div className=" text-small d-md-none job-data-card">
                                                VACANCY:
                                                <span className="d-md-none">
                                                  {item?.postDetails?.posting
                                                    ?.noOfVacancies || ""}
                                                </span>
                                              </div>
                                              <div className="tableBodyFont-top d-none d-md-inline">
                                                {item?.postDetails?.posting
                                                  ?.noOfVacancies || ""}
                                                <span className="d-none d-md-inline mx-2 tableBodyFont-top ">
                                                  No of Vacancy
                                                </span>{" "}
                                              </div>
                                              <div>
                                                <span className="icon-calendar me-2"></span>
                                                <span className="tableBodyFont-top ">
                                                  {daysLeft}
                                                </span>
                                              </div>
                                              {openingDate && (
                                                <div className="mt-1">
                                                  <span className="tableBodyFont-top text-muted" style={{ fontSize: "12px" }}>
                                                    Application Opening Date: {openingDate}
                                                  </span>
                                                  <br />
                                                  <span className="tableBodyFont-top text-muted" style={{ fontSize: "12px" }}>
                                                    Application Opening Time: 02:00 PM
                                                  </span>
                                                </div>
                                              )}
                                            </Col>
                                            <Col
                                              xs="4"
                                              md="2"
                                              className="d-flex justify-content-center flex-column align-items-center"
                                            >
                                              {appliedJobs.includes(
                                                item?.postDetails?.posting?._id
                                              ) ? (
                                                <Button
                                                  variant="secondary"
                                                  size="sm"
                                                  disabled
                                                  className="alljobBtn ps-3 pe-3 pt-2 pb-2 applied-btn"
                                                >
                                                  APPLIED
                                                </Button>
                                              ) : daysLeft ===
                                                "The last date for applying to the vacancy is over." ? (
                                                <Button
                                                  variant="primary"
                                                  size="sm"
                                                  disabled
                                                  className="alljobBtn ps-3 pe-3 pt-2 pb-2 close-btn"
                                                >
                                                  CLOSED
                                                </Button>
                                              ) : !isOpened ? (
                                                <Button
                                                  variant="primary"
                                                  size="sm"
                                                  disabled
                                                  className="alljobBtn ps-3 pe-3 pt-2 pb-2 close-btn"
                                                  title={`Application opens on ${openingDate} at 02:00 PM`}
                                                >
                                                  NOT OPENED
                                                </Button>
                                              ) : (
                                                <Button
                                                  variant="primary"
                                                  size="sm"
                                                  onClick={(e) => {
                                                    console.log(
                                                      "post",
                                                      item?.postDetails,
                                                      "item",
                                                      item
                                                    );
                                                    e.preventDefault();
                                                    handleRegisterFinal(
                                                      item,
                                                      item?.postDetails
                                                    );
                                                  }}
                                                  className="alljobBtn ps-3 pe-3 pt-2 pb-2 apply-btn"
                                                >
                                                  APPLY
                                                </Button>
                                              )}
                                            </Col>
                                          </Row>
                                        </Card.Body>
                                      </Card>
                                    </>
                                  );
                                })}
                              </>
                            </div>
                          </div>
                        </Tabs>
                      </div>
                    </div>
                  </div>
                </div>
                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  pageCount={totalPage}
                />
              </Card>
            </section>
          </>
        )}
      </div>
      <div className="custom-footer pt-3 pb-3">
        <p className="custom-footer-text">
          © 2024 Odisha Mining Corporation Ltd. (O M C LTD)
        </p>
      </div>
      {/* <Footer /> */}
      <Gotop />
    </>
  );
}

export default AllJobs;
